import { IInitialChatData } from '../../../server/service/InitialChatData';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { httpClient } from '../httpClient';
import { addToQueue, debug, handleConflictStatus } from './utils';

const { clientTopology, queryParams: query } = renderModel.get();

export const getLiveChatMessages = (messageId: string) => {
  if (!messageId) {
    return;
  }

  return httpClient
    .getInstance()
    .get<IInitialChatData>(clientTopology.messagesUrl, {
      params: { lastMessageId: messageId },
    })
    .then(handleConflictStatus) // I think not
    .then((res) => {
      try {
        // fixing race condition between response from user action and duplexer
        // if there is an empty response it could affect the real changes from UA
        if (!res.data?.ui && !res.data?.messages?.length) {
          return;
        }
        return addToQueue(res);
      } catch (error) {
        logger.error({
          message: 'fail to process live chat messages response',
          error,
          callParams: {
            query,
            response: res,
          },
        });
      }
    })
    .then(debug)
    .catch((error) => {
      logger.error({
        message: 'fail to getLiveChatMessages',
        error,
        callParams: {
          query,
        },
      });
    });
};
